import * as Yup from 'yup'

const validateUserName = value => {
  return !!value.trim().match(/^[a-zA-Z\s]*$/)
}

const isInputEmpty = value => {
  return value.trim().length === 0
}

const isTooShort = value => {
  return value.trim().replace(/\s\s+/g, ' ').length < 2
}

const isTooLong = value => {
  return value.trim().replace(/\s\s+/g, ' ').length > 15
}

const nameSchema = Yup.string()
  .test('is-empty', 'Required', value => value && !isInputEmpty(value))
  .test('is-too-short', 'Too short', value => value && !isTooShort(value))
  .test('is-too-long', 'Too long', value => value && !isTooLong(value))
  .test(
    'is-valid-name',
    'Invalid name',
    value => value && validateUserName(value)
  )

const emailSchema = Yup.string()
  .email()
  .required('Required')

const passwordSchema = Yup.string()
  .min(6)
  .required('Required')

export const loginSchema = Yup.object().shape({
  email: emailSchema,
  password: passwordSchema
})

export const signupSchema = Yup.object().shape({
  email: emailSchema,
  password: passwordSchema,
  firstName: nameSchema,
  lastName: nameSchema
})



// WEBPACK FOOTER //
// ./src/modules/Checkout/AccountForm/validationSchema.js